<!-- 进度-->
<template>
  <div>
    <div class="progress">
      <!-- 心愿详情进度 内容区 -->
      <div class="progress_content">
        <!-- 进度条 -->
        <div class="progress_line"></div>
        <div
          class="progress_content_item"
          v-for="(process, index) in list"
          :key="index"
        >
          <div class="progress_times" v-if="index < showDataNum">
            <span class="progress_time">{{ process.date }}</span>
            <img
              class="progress_circle"
              src="http://img.wish.hebyun.com.cn/images/circle.png"
            />
          </div>
          <div class="progress_infos" v-if="index < showDataNum">
            <div class="progress_words">{{ process.content }}</div>
            <div class="progress_imgs" v-if="process.imglist">
              <div v-for="(i, index) in process.imglist" :key="index">
                <img
                  v-if="i.type === 1"
                  :src="i.file_url"
                  @click="showPreview($event)"
                />
                <video v-if="i.type === 2" :src="i.file_url"></video>
              </div>
            </div>
          </div>
          <!-- 删除按钮 -->
          <img
            v-if="index < showDataNum && isUpdate"
            class="delete_btn"
            src="http://img.wish.hebyun.com.cn/images/delete_.png"
            alt=""
            @click="handleDelete(process.id)"
          />
        </div>
      </div>
      <!-- 查看更多进度 -->
      <div
        class="more"
        @click="isUpdate ? showMore : ''"
        v-if="showDataNum < dataLength && !isHideMore"
      >
        查看更多进度>>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: ["list", "isUpdate", "isHideMore"],
  data() {
    return {
      showDataNum: 3,
      dataLength: 0,
      imgShow: false,
      images: [],
      // isShow:true
    };
  },
  created() {
    this.dataLength = this.list.length;
  },
  methods: {
    showMore() {
      this.showDataNum = this.dataLength;
    },

    // 删除某条进度
    async handleDelete(id) {
      let that=this;
      this.$dialog
        .confirm({
          message: "确认删除么？",
        })
        .then(() => {
          that.$api.deleteProcess({ id: id });
          that.$toast("删除成功");
          // that.$emit("refresh");
          that.$router.go(-1)
        });
    },

    showPreview($event) {
      this.imgShow = true;
      ImagePreview({ images: [$event.target.src] });
    },
  },
};
</script>
<style lang="scss">
.progress {
  margin-top: 30px;
  position: relative;
  .progress_content {
    position: relative;
    padding: 0 15px 0;
    overflow: hidden;
    /* 进度条 */
    .progress_line {
      flex-direction: column;
      position: absolute;
      top: 5px;
      left: 52.5px;
      width: 1px; /*no*/
      height: 100%;
      background-color: #ff0000;
    }
    .progress_content_item {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 10px;
      .progress_times {
        display: inline-flex;
        align-items: center;
        height: 33px;
        .progress_time {
          display: block;
          width: 34px;
          font-size: 12px;
          color: #666666;
          text-align: left;
        }
        .progress_circle {
          position: relative;
          width: 8.5px;
          height: 8.5px;
          margin-left: 0;
          background-color: #fff8d6;
          border-radius: 50%;
          z-index: 10;
        }
      }
      .progress_infos {
        display: flex;
        align-items: center;
        position: relative;
        padding: 4px 25px 4px 12px;
        width: 245px;
        min-height: 33px;
        box-sizing: border-box;
        background-color: #ffdfc0;
        border-radius: 10px;
        flex-wrap: wrap;
        .progress_words {
          font-size: 16px;
          line-height: 1.5;
          color: #666666;
          text-align: left;
          width: 100%;
        }
        .progress_imgs {
          display: flex;
          margin-top: 9px;
          img {
            width: 48px;
            height: 48px;
            margin-right: 5px;
          }
        }
      }
      .progress_infos::before {
        content: "";
        position: absolute;
        left: -28px;
        top: 12px;
        width: 7.5px;
        border-right: 13px solid #ffdfc0;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        border-left: 13px solid transparent;
      }
      .delete_btn {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 12px;
        height: 12px;
      }
    }

    .progress_content_item:last-child {
      margin-bottom: 0;
    }
  }

  .more {
    width: 100%;
    font-size: 13px;
    color: #e50012;
    width: 100%;
    text-align: center;
    padding-bottom: 20px;
    padding-top: 0;
  }
}
</style>
